// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".data-crafter-preview main.main-layout.ant-layout-content {\n  margin-top: 0;\n}\n", "",{"version":3,"sources":["webpack://src/modules/data_crafter_app/screens/DataCrafterAppOutputPreviewScreen/DataCrafterAppOutputPreviewScreen.less"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".data-crafter-preview main.main-layout.ant-layout-content {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
